import { Component, Inject, inject } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import moment from  'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { StockingServiceService } from '../../stocking-service.service';
import { AuthService } from 'src/app/services/auth.service';
import { last, map, Observable, startWith, Subject } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDatepicker } from '@angular/material/datepicker';
import { Email, EmailService } from 'src/app/services/email.service';
import { DeliveryEmailService } from '../delivery-email.service';

@Component({
  selector: 'app-new-delivery-dialog',
  templateUrl: './new-delivery-dialog.component.html',
  styleUrl: './new-delivery-dialog.component.css'
})
export class NewDeliveryDialogComponent {
  private _formBuilder = inject(FormBuilder);
  private selectedDate = moment()
  private relevantMenu: any = null
  private systems: any[] = []
  private filteredSystems: Observable<string[]>;
  private timeLimitToday = moment().hour(14).startOf('hour');

  isUnlocked = false;

  assetsLoaded = 0;
  assetsToLoad = 2;

  selectedProducts: any[] = []

  extraDeliveryTypes = [
    "Cutomer order",
    "Sales meeting",
    "Foodbox for promotion",
    "Kick-off"
  ]

  whenFormGroup = this._formBuilder.group({
    typeDelivery: [this.extraDeliveryTypes[0], Validators.required],
    date: [new Date, Validators.required],
  });
  costumerFormGroup = this._formBuilder.group({
    system: ['', Validators.required],
    desciption: ['', Validators.required],
    comment: [''],
  });
  whatFormGroup = this._formBuilder.group({
    presets: [''],
    product: [''],
    hidden: ['', Validators.required],
  });
  isLinear = true;

  hollyDays: any[] = []

  settings: any = null;

  createrMail = null;
  createrName = null;

  dataSource$: Subject<any[]> = new Subject<any[]>();

  dataSource: any[] = [
    { name: "Cutomer order" },
    { name: "Sales meeting" },
    { name: "Foodbox for promotion" },
    { name: "Kick-off" }
  ];

  constructor(
    public dialogRef: MatDialogRef<NewDeliveryDialogComponent>, @Inject(MAT_DIALOG_DATA) public data,
    private stockingService: StockingServiceService,
    public auth: AuthService,
    private emailService: EmailService,
    private deliveryEmails: DeliveryEmailService
  ) {

    this.stockingService.getHollydays$().subscribe((hollydays) => {
      this.hollyDays = hollydays.map((hollyday) => hollyday.date);
      this.assetsLoaded++;
    })

    // this.onDateSelect("type", { value: moment() });
    this.stockingService.getStockingSettings$().subscribe((data: any) => {
      // From snapshot
      this.settings = data.data()
      console.log("Settings: ", this.settings)
      this.timeLimitToday = moment().hour(this.settings.lastOrderTime).minute(0).startOf('hour');
      this.assetsLoaded++;

      if (!this.data.delivery) {

        let nextDate = moment();

        while (!this.dateFilter(nextDate)) {
          nextDate.add(1, 'days');
        }

        this.whenFormGroup.get('date').setValue(nextDate.toDate());

        this.loadMenu(nextDate);
      } else {
        this.loadMenu(moment(this.data.delivery.date, "DD.MM.YYYY"));
      }
    });


    auth.user$.subscribe((user: any) => {
      if (user) {

        this.createrMail = user.email;
        this.createrName = user.Name;


        this.stockingService.getSystems$().subscribe((systems) => {
          console.log("Systems: ", systems.length)
          this.systems = systems.filter((system) => {
            return user.sites.includes(system.siteId);
          }).sort((a, b) => a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase())) as any[]

          this.filteredSystems = this.costumerFormGroup.get('system').valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value || '')),
          );

          if (this.data.delivery) {

            console.log("Delivery data: ", this.data.delivery)

            const delivery = this.data.delivery;
            const system = this.systems.filter((system) => system.id == delivery.systemId)[0]

            if(delivery.typeDelivery == this.extraDeliveryTypes[0]) {
              this.costumerFormGroup.get('system').setValidators([Validators.required]);
              this.costumerFormGroup.get('system').updateValueAndValidity();
            }


            this.whenFormGroup.get('typeDelivery').setValue(delivery.typeDelivery);
            this.whenFormGroup.get('date').setValue(moment(delivery.date, "DD.MM.YYYY").toDate());
            this.costumerFormGroup.get('system').setValue(system);
            this.costumerFormGroup.get('desciption').setValue(delivery.desciption);
            this.costumerFormGroup.get('comment').setValue(delivery.comment);
            this.whatFormGroup.get('hidden').setValue('Hidden');
            this.selectedProducts = this.data.delivery.products.map((product) => {
              console.log("Product: ", product, this.getMaxAmount({id: product.productId, productType: product.productType}))
              return {
                amount: product.amount,
                max: 0, //this.getMaxAmount({id: product.productId}),
                product: {
                  id: product.productId,
                  name: product.product,
                  productType: product.productType
                },
                newProduct: null
              }
            })
            this.assetsLoaded++;

            this.dataSource$.next(this.selectedProducts)
          }
        })
      }
    })

    this.costumerFormGroup.get('system').valueChanges.subscribe((value: any) => {
      if (value && !this.data.delivery) {
        this.costumerFormGroup.get('desciption').setValue(value.name);

      }
    });



  }

  getPresets() {
    return this.settings ? this.settings.extraDeliveryPresets : [];
  }

  onSelectPreset(preset) {

    const selectedPreset = preset.value;

    this.selectedProducts = [];

    Object.keys(selectedPreset.products).forEach((productType) => {
      const product = this.relevantMenu.data[productType].product
      this.selectedProducts.push({
        amount: selectedPreset.products[productType],
        max: this.getMaxAmount(product),
        product: {
          id: product.id,
          name: product.name,
          productType: productType
        },
        newProduct: {
          id: this.relevantMenu.data[productType].product.id,
          name: this.relevantMenu.data[productType].product.name,
          productType: this.relevantMenu.data[productType].product.productType
        }
      })

    })
    this.whatFormGroup.get('hidden').setValue('Hidden');


    this.dataSource$.next(this.selectedProducts);

    console.log("Preset", preset)
  }

  allAssetsLoaded() {
    return this.assetsLoaded >= this.assetsToLoad
  }

  onDateSelect(type, event) {
    // Empty products
    this.whatFormGroup.get('presets').setValue('');
    this.selectedProducts = []
    this.dataSource$.next(this.selectedProducts)

    this.selectedDate = moment(event.value)

    this.loadMenu(this.selectedDate);
  }

  loadMenu(date) {
    this.selectedDate = moment(date)

    this.stockingService.getMenu$(this.selectedDate.week(), this.selectedDate.year()).subscribe((menu) => {
      if (menu['data']) {
        this.relevantMenu = menu
        this.isUnlocked = !menu['locked'];

        this.selectedProducts = this.selectedProducts.map((product) => {
          const productType = product.product.productType
          const newProduct = this.relevantMenu['data'][productType].product

          if (newProduct) {
            product.newProduct = {
              id: newProduct.id,
              name: newProduct.name,
              productType: newProduct.productType
            }
          } else {
            product.newProduct = null
          }

          return product;
        })

      } else {
        this.relevantMenu = null
      }

    })

  }

  menuIsLocked() {
    return this.relevantMenu ? this.relevantMenu.locked : true
  }


  onNextOnTypeForm() {
    this.updateProductsWithNewMenu();
  }

  updateProductsWithNewMenu() {
    console.log("Relevant menu", this.relevantMenu)
    console.log("Selected products", this.selectedProducts)
    this.selectedProducts = this.selectedProducts.map((product) => {



      return product;

    })

    this.dataSource$.next(this.selectedProducts)
  }

  getProduct(productType) {
    return this.relevantMenu.data[productType].product.name
  }

  ngOnInit() {

  }

  dateFilter = (date: moment.Moment | null) => {
    const day = moment(date).day();
    const today = moment();
    const isToday = moment(date).isSame(today, 'day');
    const isWeekend = day === 0 || day === 6; // Sunday or Saturday
    const isBeforeToday = moment(date).isBefore(today, 'day');
    const isToLateForToday = isToday ? moment().isAfter(this.timeLimitToday) : null;
    const isHollyday = this.hollyDays.map((hollyday) => hollyday.format("YYYY-MM-DD")).includes(moment(date).format("YYYY-MM-DD"));
    // console.log("date", date.format("YYYY-MM-DD HH:mm:ss"))
    // console.log("this.timeLimitToday", this.timeLimitToday.format("YYYY-MM-DD HH:mm:ss"))
    // console.log("isToLateForToday", isToLateForToday)
    return (!isWeekend && !isBeforeToday && !isToLateForToday && !isHollyday);
  };

  private _filter(value: string): string[] {
    if (typeof value === 'object' && value !== null) return []

    const filterValue = value.toLowerCase();

    const filteredSystems = this.systems.filter(option => option.name.toLowerCase().includes(filterValue));

    return filteredSystems;
  }

  displayFn(system: any): string {
    return system && system.name ? system.name : '';
  }

  onTypeDeliveryChange(event: any) {
    console.log(event, this.extraDeliveryTypes[0])
    this.whenFormGroup.get('typeDelivery').setValue(event.value);
    if (event.value == this.extraDeliveryTypes[0]) {
      console.log("Set validators")
      this.costumerFormGroup.get('system').setValidators([Validators.required]);
    } else {
      console.log("Clear validators")
      this.costumerFormGroup.get('system').clearValidators();
    }
    this.costumerFormGroup.get('system').updateValueAndValidity();
  }


  getMenuProducts(category) {


    if (this.relevantMenu) {
      return Object.keys(this.relevantMenu.data).map((product) => {

        const productData = this.relevantMenu.data[product].product

        return productData
      }).sort((a, b) => a.name.localeCompare(b.name))
    } else {
      return []
    }
  }

  getMaxAmount(product) {

    // Find product in menu
    const productId = product.id;

    console.log("Product ID: ", productId)

    console.log("productType: ", product.productType)

    const productType = product.productType ? product.productType:  Object.keys(this.relevantMenu.data).find((key) => {
      return this.relevantMenu.data[key].product.id === productId;
    });


    const amount = this.relevantMenu.data[productType].amounts[moment(this.selectedDate).weekday() - 1];
    
    return Math.round(amount * 0.1)
  }

  getCategorys() {
    if (this.relevantMenu) {
      return Object.keys(this.relevantMenu.data).map((product) => {
        const productData = this.relevantMenu.data[product].product
        console.log("Product data: ", productData)
        // return productData?.categories[0]
        return productData.name
      }).filter((category, index, self) => {
        return self.indexOf(category) === index
      }).sort((a, b) => a.localeCompare(b))

    } else {
      return []
    }
  }


  addProduct() {

    if (!this.whatFormGroup.get('product').value) return;

    const product: any = this.whatFormGroup.get('product').value

    const productType = Object.keys(this.relevantMenu.data).find((key) => {
      return this.relevantMenu.data[key].product.id === product.id;
    });

    console.log("Product type: ", productType)

    product.productType = productType;

    const max = this.getMaxAmount(product);

    // if in list already, return
    if (this.selectedProducts.map(p => p.product.id).includes(product.id)) {

      const index = this.selectedProducts.map(p => p.product.id).indexOf(product.id)
      if (this.selectedProducts[index].amount < this.selectedProducts[index].max) this.selectedProducts[index].amount += 1

    } else {
      this.selectedProducts.push({
        amount: 1,
        max,
        product,
        hasChanged: false,
        oldProduct: null,
        newProduct: {
          id: this.relevantMenu.data[product.productType].product.id,
          name: this.relevantMenu.data[product.productType].product.name,
          productType: this.relevantMenu.data[product.productType].product.productType
        }
      })

    }
    this.whatFormGroup.get('hidden').setValue('Hidden');

    this.dataSource$.next(this.selectedProducts)
  }

  removeProduct(product) {
    const index = this.selectedProducts.map(p => p.product.id).indexOf(product.product.id)
    if (index > -1) {
      this.selectedProducts.splice(index, 1)
    }

    if (this.selectedProducts.length == 0) {
      this.whatFormGroup.get('hidden').setValue('');
    }

    this.dataSource$.next(this.selectedProducts)
  }

  async placeOrder(copy) {

    // is valid
    if (this.whenFormGroup.invalid || this.costumerFormGroup.invalid) {
      this.whenFormGroup.markAllAsTouched();
      this.costumerFormGroup.markAllAsTouched();
      return;
    }

    const number = await new Promise((res, rej) => this.stockingService.getNextDeliveryNumber().pipe(
      last()
    ).subscribe((number) => {
      res(number);
    }));

    const system = this.costumerFormGroup.get('system').value as any

    console.log(this.selectedProducts)

    const products = this.selectedProducts.map((product) => {
      const newProduct = product.newProduct ? product.newProduct : null
      const oldProduct = product.product ? product.product : null;

      if (newProduct) {
        return {
          productType: newProduct.productType,
          product: newProduct.name,
          productId: newProduct.id,
          amount: product.amount,
          oldProduct: {
            id: oldProduct.id,
            name: oldProduct.name,
            productType: oldProduct.productType
          },
          newProduct: {
            id: newProduct.id,
            name: newProduct.name,
            productType: newProduct.productType
          }
        }
      } else {
        return {
          productType: product.product.productType,
          product: product.product.name,
          productId: product.product.id,
          amount: product.amount
        }
      }
    })

    const date = moment(this.whenFormGroup.get('date').value)

    const isUpdatedOrder = this.data.delivery && !copy;
    const order = {
      ...this.data.delivery,
      typeDelivery: this.whenFormGroup.get('typeDelivery').value,
      date: date.format(),
      dateUnix: date.unix(),
      week: date.week(),
      year: date.year(),
      email: this.createrMail,
      name: this.createrName,
      created: moment().format(),
      createdUnix: moment().unix(),
      systemId: system ? system.id : null,
      systemName: system ? system.name : null,
      desciption: this.costumerFormGroup.get('desciption').value,
      comment: this.costumerFormGroup.get('comment').value,
      deliveryNumber: isUpdatedOrder ? this.data.delivery.deliveryNumber : number,
      products,
      status: "Sheduled",
    }

    let orderId = null;


    if (isUpdatedOrder) {
      orderId = this.data.delivery.id;


      await this.sendLogsticsEmail(order, true);

      if (order.typeDelivery === "Sales meeting") {

        // Create mail to IL
        this.sendIlEmail(order, true);

        // console.log("IL email sent: ", ilEmailRef)

      } else if (order.typeDelivery === "Kick-off") {
        // Create mail to IL
        await this.sendIlKickoffEmail(order, true);

      }

      this.orderConfirmationEmail(order, true);

    } else if (!this.data.delivery || copy) {

      // Mail to logstics
      const logsticsEmailRef = await this.sendLogsticsEmail(order, false);
      console.log("Logstics email sent: ", logsticsEmailRef)

      order['logsticsEmailRef'] = logsticsEmailRef;

      if (order.typeDelivery === "Sales meeting") {


        // Create mail to IL
        const ilEmailRef = await this.sendIlEmail(order, false);
        if (ilEmailRef) {
          console.log("IL email sent: ", ilEmailRef)
          order['ilEmailRef'] = ilEmailRef;
        } else {
          console.log("No IL email sent, no fresh products")
        }

        // console.log("IL email sent: ", ilEmailRef)

      } else if (order.typeDelivery === "Kick-off") {
        // Create mail to IL
        const ilKickoffEmailRef = await this.sendIlKickoffEmail(order, false);

        if (ilKickoffEmailRef) {
          console.log("IL Kick-off email sent: ", ilKickoffEmailRef)
          order['ilEmailRef'] = ilKickoffEmailRef;
        } else {
          console.log("No IL email sent, no fresh products")
        }

      }

      this.orderConfirmationEmail(order, false);
    }

    this.stockingService.updateExtraDelivery(order, orderId).then(() => {
      this.dialogRef.close();

    }).catch((error) => {
      console.error("Error adding document: ", error);
    });

  }

  // These four delegate to DeliveryEmailService so that approving a customer's
  // portal order on the Extra Deliveries page produces byte-identical mail to an
  // order an operator creates here.
  sendLogsticsEmail(order, update) {
    return this.deliveryEmails.sendLogisticsEmail(order, this.settings, update);
  }

  sendIlEmail(order, update) {
    return this.deliveryEmails.sendIlEmail(order, this.settings, update);
  }

  orderConfirmationEmail(order, update) {
    return this.deliveryEmails.orderConfirmationEmail(order, update);
  }

  sendIlKickoffEmail(order, update) {
    return this.deliveryEmails.sendIlKickoffEmail(order, this.settings, update);
  }

  cancelOrder() {
    if (this.data.delivery) {
      // this.stockingService.deleteExtraDelivery(this.data.delivery.id).then(() => {


      // date:"28.05.2025"
      const sendAtMoment = moment(this.data.delivery.date, "DD.MM.YYYY").subtract(1, 'days').hour(8).minute(0).second(0);

      const deliveryDate = moment(this.data.delivery.date, "DD.MM.YYYY");

      console.log("Del: ", this.data.delivery)
      console.log("Send at moment: ", sendAtMoment.format("YYYY-MM-DD HH:mm:ss"))
      console.log("Current moment: ", moment().format("YYYY-MM-DD HH:mm:ss"))

      if (sendAtMoment.isBefore(moment())) {

        // Send cancle mail to logistics
        const cancelEmail: Email = {
          emailTo: this.settings.logisticsEmail,
          cc: this.createrMail,
          subject: `Cancelled Logistics Extra Delivery #${this.data.delivery.deliveryNumber} (Do not reply)`,
          emailFrom: "stocking@cuboid.no",
          title: ``,
          html: `
                <p><strong>Cancelled delivery:</strong></p>
                <p><strong>Creator:</strong> ${this.createrName} (${this.createrMail})</p>
                <p><strong>Delivery Number:</strong> ${this.data.delivery.deliveryNumber}</p>
                <p><strong>Type:</strong> ${this.data.delivery.typeDelivery}</p>
                <p><strong>Date:</strong> ${deliveryDate.format("dddd, DD.MM.YYYY")}</p>
                <p><strong>Description:</strong> ${this.data.delivery.desciption}</p>
                <p><strong>Comment:</strong> ${this.data.delivery.comment}</p>
                <p><strong>This mail is automatically sendt, please do not reply.</strong> </p>`,
          text: '',
          includeSignature: true,
          signatureType: 'frigg',
          asap: true,
        }

        this.emailService.sendEmail(cancelEmail).then(() => {
          this.dialogRef.close();
        }).catch((error) => {
          console.error("Error sending cancel email: ", error);
        });

      } else {
        this.emailService.cancelEmail(this.data.delivery.logsticsEmailRef).then(() => {
          this.dialogRef.close();
        }).catch((error) => {
          console.error("Error cancelling email: ", error);
        });
      }

      // Cancle email to IL if it was sent
      if (this.data.delivery.ilEmailRef) {
        const ilEmail: Email = {
          emailTo: this.settings.ilEmail,
          cc: this.createrMail,
          subject: `Cancelled Extra Delivery IL #${this.data.delivery.deliveryNumber} (Do not reply)`,
          emailFrom: "stocking@cuboid.no",
          title: ``,
          html: `
                <p><strong>Cancelled delivery:</strong></p>
                <p><strong>Creator:</strong> ${this.createrName} (${this.createrMail})</p>
                <p><strong>Delivery Number:</strong> ${this.data.delivery.deliveryNumber}</p>
                <p><strong>Type:</strong> ${this.data.delivery.typeDelivery}</p>
                <p><strong>Date:</strong> ${deliveryDate.format("dddd, DD.MM.YYYY")}</p>
                <p><strong>Description:</strong> ${this.data.delivery.desciption}</p>
                <p><strong>Comment:</strong> ${this.data.delivery.comment}</p>
                <p><strong>This mail is automatically sendt, please do not reply.</strong> </p>`,
          text: '',
          includeSignature: true,
          signatureType: 'frigg',
          asap: true,
        }

        this.emailService.sendEmail(ilEmail).then(() => {
          this.dialogRef.close();
        }).catch((error) => {
          console.error("Error sending cancel email to IL: ", error);
        });
      }

      // Order cancled confimation email to creator
      const cancelConfirmEmail: Email = {
        emailTo: this.createrMail,
        subject: `Cancelled Extra Delivery #${this.data.delivery.deliveryNumber} (Do not reply)`,
        emailFrom: "stocking@cuboid.no",
        title: ``,
        html: `
                <p><strong>Cancelled delivery:</strong></p>
                <p><strong>Creator:</strong> ${this.createrName} (${this.createrMail})</p>
                <p><strong>Delivery Number:</strong> ${this.data.delivery.deliveryNumber}</p>
                <p><strong>Type:</strong> ${this.data.delivery.typeDelivery}</p>
                <p><strong>Date:</strong> ${moment(this.data.delivery.date).format("dddd, DD.MM.YYYY")}</p>
                <p><strong>Description:</strong> ${this.data.delivery.desciption}</p>
                <p><strong>Comment:</strong> ${this.data.delivery.comment}</p>
                <p><strong>This mail is automatically sendt, please do not reply.</strong> </p>`,
        text: '',
        includeSignature: true,
        signatureType: 'frigg',
        asap: true,
      }

      this.emailService.sendEmail(cancelConfirmEmail).then(() => {
        this.dialogRef.close();
      }).catch((error) => {
        console.error("Error sending cancel confirmation email: ", error);
      });

      // }).catch((error) => {
      //   console.error("Error deleting document: ", error);
      // });
    } else {
      this.dialogRef.close();
    }
  }


  orderInDateRange() {
    if (!this.data.delivery) return true

    const date = moment(this.data.delivery.date, "DD.MM.YYYY")

    return this.dateFilter(date)
  }

  close() {
    this.dialogRef.close();
  }

}
